import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from 'src/app/finance/finance.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { SERVICE_STATUS } from '../../conf/requirements';

@Component({
    selector: 'app-service-detail-files',
    templateUrl: './service-detail-files.component.html',
    styleUrls: ['./service-detail-files.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceDetailFilesComponent implements OnInit {

	@Input() service: any;
	@Input() showProject: boolean = true;
	@Input() isShooting: boolean = false;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	@Output() onStatusChange = new EventEmitter<any>();
	readonly SERVICE_STATUS = SERVICE_STATUS;
	loading: boolean = false;
	serviceFiles: any = [];
	selectedService: any;
	isUpdatingService: boolean = false;

	close() {
		this.closeView.emit()
	}

	update() {
		this.loadServiceFiles(true);
	}

	loadServiceFiles(isUpdate?) {
		this.loading = true;
		this._fiS.getFilesServices(this.selectedService.id).subscribe(
			(data: any) => {
				this.serviceFiles = data.files;
				this.loading = false;
			}
		)
	}

	adjustDataShooting() {
		let formatTimezone = 'yyyy-MM-ddTHH:mm:ss.SSSZZZZZ';
		if (this.selectedService.wrap) {
			let date = new Date();
			let timesSplit = this.selectedService.wrap.split(':');
			this.selectedService.wrap = this._dP.transform(date.setHours(timesSplit[0], timesSplit[1]), formatTimezone);
		}
		if (this.selectedService.call_time) {
			let date = new Date();
			let timesSplit = this.selectedService.call_time.split(':');
			this.selectedService.call_time = this._dP.transform(date.setHours(timesSplit[0], timesSplit[1]), formatTimezone);
		}
		if (this.selectedService.arrive) {
			let date = new Date();
			let timesSplit = this.selectedService.arrive.split(':');
			this.selectedService.arrive = this._dP.transform(date.setHours(timesSplit[0], timesSplit[1]), formatTimezone);
		}

		this.selectedService.total_cost = (this.selectedService.cost_unit * this.selectedService.quantity) + this.selectedService.lunch + this.selectedService.extra + this.selectedService.periphery;
	}

	changeStatusService(newStatus) {
		this.loading = true;
		this._fiS.changeServiceStatus(this.service.id, newStatus).subscribe(
			data => {
				this.setUpdatingText();
				this.isUpdatingService = true;
				this.onStatusChange.emit();
				this.loading = false;
			}
		);
	}

	setUpdatingText() {
		this.selectedService.se_st_name_eng = 'updating';
		this.selectedService.se_st_name_esp = 'actualizando';
		this.service.se_st_name_eng = 'updating';
		this.service.se_st_name_esp = 'actualizando';
		this._cD.detectChanges();
	}

	constructor(
		private _dP: DatePipe,
		private _cD: ChangeDetectorRef,
		public _gS: GlobalService,
		private _fiS: FinanceService) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.service) {
			this.selectedService = JSON.parse(JSON.stringify(this.service));
			if (this.isShooting) {
				this.adjustDataShooting();
			}
			this.loadServiceFiles();
			this.isUpdatingService = false;
		}
	}

}
